// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const PrintIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg width={width} height={height} viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg">
          <path fill="inherit" d="M28.875 8.25H26.8125V2.0625C26.8125 0.928125 25.8844 0 24.75 0H8.25C7.11562 0 6.1875 0.928125 6.1875 2.0625V8.25H4.125C1.85625 8.25 0 10.1062 0 12.375V24.75V26.8125H2.0625H6.1875V30.9375C6.1875 32.0719 7.11562 33 8.25 33H24.75C25.8844 33 26.8125 32.0719 26.8125 30.9375V26.8125H30.9375H33V24.75V12.375C33 10.1062 31.1438 8.25 28.875 8.25ZM8.25 2.0625H24.75V8.25H8.25V2.0625ZM24.75 30.9375H8.25V18.5625H24.75V30.9375ZM30.9375 24.75H26.8125V18.5625C26.8125 17.4281 25.8844 16.5 24.75 16.5H8.25C7.11562 16.5 6.1875 17.4281 6.1875 18.5625V24.75H2.0625V12.375C2.0625 11.2406 2.99062 10.3125 4.125 10.3125H28.875C30.0094 10.3125 30.9375 11.2406 30.9375 12.375V24.75ZM22.6875 21.6562H10.3125V20.625H22.6875V21.6562ZM22.6875 24.75H10.3125V23.7188H22.6875V24.75ZM22.6875 27.8438H10.3125V26.8125H22.6875V27.8438ZM28.875 13.4062C28.875 13.9734 28.4109 14.4375 27.8438 14.4375C27.2766 14.4375 26.8125 13.9734 26.8125 13.4062C26.8125 12.8391 27.2766 12.375 27.8438 12.375C28.4109 12.375 28.875 12.8391 28.875 13.4062Z" />
        </svg>
      )
    }
  </Icon>
);

export default PrintIcon;
